export default __webpack_public_path__ + "static/media/egg.b76ab1eb.png";